import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { routesName } from "core";
import { AddCategory } from "./addCategory";
import { CategoriesList } from "./categoriesList";
import { EditCategory } from "./editCategory";


const Categories = memo(() => {
  return (
    <Routes>
      <Route path={routesName.ADDCATEGORY} element={<AddCategory />} />
      <Route path={routesName.CATEGORIESLIST} element={<CategoriesList />} />
      <Route path={routesName.EDITCATEGORY} element={<EditCategory />} />
    </Routes>
  );
});

export { Categories };
